import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';

export function getTranslatedMenuItem(
  menuItem: MenuItem,
  translateService: TranslateService,
  replaceWithPathById?: Record<string, string>,
  replaceWithLabelById?: Record<string, string>,
): MenuItem {
  const toReturn: MenuItem = cloneDeep(menuItem);
  if (replaceWithPathById && toReturn.routerLink) {
    Object.keys(replaceWithPathById).forEach((key) => {
      toReturn.routerLink = toReturn.routerLink.replace(
        `:${key}`,
        replaceWithPathById[key],
      );
    });
  }

  if (replaceWithLabelById && toReturn.label) {
    Object.keys(replaceWithLabelById).forEach((key) => {
      toReturn.label = (toReturn.label as string).replace(
        `:${key}`,
        replaceWithLabelById[key],
      );
    });
  }

  if (toReturn.label) {
    toReturn.label = translateService.instant(toReturn.label);
  }

  if (menuItem.id) {
    if (replaceWithPathById && menuItem.id in replaceWithPathById) {
      menuItem;
    }
  }

  return toReturn;
}
